import { resolveRunePage, applyRunePageToEntity } from '../../domain/runes/runePage.js';

/**
 * applyLobbyRunes — apply Season 2 rune page from lobby matchConfig onto player.
 */
export function applyLobbyRunes(matchConfig, playerEntity, inventory) {
  if (!matchConfig || !playerEntity || !matchConfig.runePage) return false;
  const page = resolveRunePage(matchConfig.runePage);
  if (!page) return false;
  const hasInventory = inventory && typeof inventory.recalculateStats === 'function';
  const result = applyRunePageToEntity(playerEntity, page, {
    applyOwnedCombatStats: !hasInventory
  });
  if (!result.ok) return false;
  if (hasInventory) inventory.recalculateStats();
  return true;
}
